export const RESIDENCYLIST = ['Citizen','Permanent Resident','Work Permit','Student Visa','Other'] as const;

export const INSOLVENCYLIST = ['Active','Discharged','In process','None'] as const;

export const LIABILITYLIST = ['Joint','Split','Individual'] as const;